// extracted by mini-css-extract-plugin
export default {"page":"newCharacter_page__OIOJN"};